// Library imports
import { Col, Row } from "antd";
import styled from "styled-components";

// Local imports
import XiQLightLogo from "../../../../assets/img/Loaders/XiQLightLogo.png";
import UserListItemLoader from "./UserListItemLoader";
interface IListPlaceholderProps {
  loading: boolean;
}

const PeopleListHolder = (props: IListPlaceholderProps) => {
  const { loading } = props;
  return (
    <>
      {loading ? (
        <Wrapper>
          <Row gutter={24}>
            <Col className="gutter-row" span={24}>
              <div className="responsive-svg type-3">
                <div className="padding-bottom-sm">
                  <UserListItemLoader />
                </div>

                <div className="padding-bottom-sm">
                  <UserListItemLoader />
                </div>

                <div className="padding-bottom-sm">
                  <UserListItemLoader />
                </div>

                <div className="padding-bottom-sm">
                  <UserListItemLoader />
                </div>
              </div>
            </Col>
          </Row>
        </Wrapper>
      ) : null}
    </>
  );
};

export default PeopleListHolder;

const Wrapper = styled.div`
  /* max-width: 1200px; */
  .responsive-svg {
    background-color: #fff;
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
    overflow: hidden;
    position: relative;
    height: 100%;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    &:before {
      background-image: url(${XiQLightLogo});
      background-repeat: no-repeat;
      background-position: center;
      top: 0;
      left: 0;
      content: "";
      position: absolute;
      height: 63%;
      width: 100%;
    }
    svg {
      width: 100%;
      height: 100%;
      defs {
        linearGradient {
          stop {
            stop-color: #e9e9e9 !important;
            &:nth-of-type(2) {
              stop-color: #f6f6f6 !important;
            }
          }
        }
      }
    }
    &.type-2 {
      height: auto;
      width: 100%;
      &:before {
        background-size: 60px;
        top: 15px;
        left: 15px;
        height: calc(100% - 30px);
        min-width: 95px;
        width: 20%;
      }
    }
    &.type-3 {
      background-color: transparent;
      box-shadow: none;
      border-radius: 0px;
      height: auto;
      &:before {
        background-size: 60%;
        top: 15px;
        left: 0;
        height: calc(100% - 25px);
        width: 11%;
      }
    }
  }
`;
